import { createSlice } from "@reduxjs/toolkit";

const onlineStatusSlice = createSlice({
  name: "onlineStatus",
  initialState: {},
  reducers: {
    updateOnlineStatus: (state, action) => {
      const { userId, status } = action.payload;
      state[userId] = status;
    },
    resetOnlineStatus: () => ({}),
  },
});

export const { updateOnlineStatus, resetOnlineStatus } =
  onlineStatusSlice.actions;
export default onlineStatusSlice.reducer;
